export const CREATE_FINANCIAL_REQUEST = `
  mutation CreateFinancialRequest($object: report_financial_requests_insert_input!) {
    insert_report_financial_requests_one(object: $object) {
      id
      job_id
      report_id
      status
    }
  }
`;

export const FULFILL_FINANCIAL_REQUESTS_FOR_JOB = `
  mutation FulfillFinancialRequestsForJob($jobId: uuid!, $fulfilledBy: Int!) {
    update_report_financial_requests(
      where: { job_id: { _eq: $jobId }, status: { _eq: "pending" } }
      _set: { status: "fulfilled", fulfilled_by: $fulfilledBy, fulfilled_at: "now()" }
    ) {
      affected_rows
    }
  }
`;
